<section>
  <div class="lbl">Region</div>
  <div>{{ area.regionId ? catalogue.regionName(area.regionId) : 'Not in a region' }}</div>
  <div *ngIf="!state.readOnly" class="flex flex-wrap gap-2 mt-2">
    <button *ngIf="state.activeRegion && area.regionId !== state.activeRegion" pButton type="button" class="p-button-sm p-button-outlined" label="Put in {{ catalogue.regionName(state.activeRegion) }}" (click)="mapTools.quick('assign')"></button>
    <button *ngIf="area.regionId && !page" pButton type="button" class="p-button-sm p-button-outlined" label="Take out of {{ catalogue.regionName(area.regionId) }}" (click)="mapTools.quick('erase')"></button>
  </div>
  <div class="meta">Change the active region in the toolbar on the left. Each change saves at once and Cmd+Z undoes it.</div>
</section>

<!-- Sub-regions (#260): the ones it is in, and one more. -->
<section class="suburb-subregions" *ngIf="catalogue.subRegionRefs.length">
  <div class="lbl">Sub-regions</div>
  <div class="flex flex-wrap gap-2 align-items-center">
    <span *ngFor="let id of area.subRegions" class="sr-chip" [attr.data-subregion]="id">
      <span class="swatch ring" [style.border-color]="catalogue.subRegionColour(id)"></span>
      <a class="cursor-pointer" (click)="nav.openSubRegion(id)">{{ catalogue.subRegionName(id) }}</a>
      <button *ngIf="!state.readOnly" type="button" class="sr-x" (click)="mapTools.membership(code, id, 'remove')" [attr.aria-label]="'Take out of ' + catalogue.subRegionName(id)"><i class="pi pi-times"></i></button>
    </span>
    <span *ngIf="!area.subRegions.length" class="text-600 text-sm">In none.</span>
  </div>
  <p-dropdown *ngIf="!state.readOnly && catalogue.addableSubRegions(area).length" [baseZIndex]="12000" appendTo="body" [options]="catalogue.addableSubRegions(area)" [group]="true" optionLabel="label" optionValue="value"
              [(ngModel)]="addPick" (onChange)="addToSubRegion($event.value)" placeholder="Add to sub-region…" styleClass="mt-2 add-subregion">
    <ng-template let-g pTemplate="group"><span class="text-600 text-sm">{{ g.label }}</span></ng-template>
    <ng-template let-o pTemplate="item"><span class="swatch ring" [style.border-color]="catalogue.subRegionColour(o.value)"></span>{{ o.label }}</ng-template>
  </p-dropdown>
  <div class="meta" *ngIf="!area.regionId && !state.readOnly">It isn't in a region: adding it to a sub-region puts it in that sub-region's region too.</div>
</section>

<section class="website-page">
  <div class="lbl">Website page</div>
  <ng-container *ngIf="area.regionId; else needsRegion">
    <div class="page-state">
      <ng-container *ngIf="publisher.selectedRecord as rec; else noPage">
        <strong [class.ok]="rec.published">{{ rec.published ? 'On the website' : 'Not on the website' }}</strong>
        <span class="text-600 text-sm"> · {{ page?.label || rec.name }}</span>
      </ng-container>
      <ng-template #noPage><span class="text-600">No page yet.</span></ng-template>
    </div>
    <div *ngIf="!state.readOnly" class="flex flex-wrap gap-2 mt-2">
      <button pButton type="button" class="p-button-sm p-button-success suburb-publish" icon="pi pi-cloud-upload" [label]="publisher.selectedLive ? 'Publish changes' : 'Publish'" (click)="publisher.publishSelected('publish')"
              pTooltip="Put this suburb's page on the website preview: the Suburb template, filled from its Page tab"></button>
      <button *ngIf="publisher.selectedLive" pButton type="button" class="p-button-sm p-button-outlined p-button-danger suburb-unpublish" icon="pi pi-eye-slash" label="Un-publish" (click)="publisher.publishSelected('unpublish')"></button>
      <button pButton type="button" class="p-button-sm p-button-outlined" icon="pi pi-pencil" label="Edit page" (click)="nav.setTab('page')"></button>
      <button *ngIf="publisher.selectedRecord && !publisher.selectedLive" pButton type="button" class="p-button-sm p-button-text p-button-danger" icon="pi pi-trash" label="Remove" (click)="publisher.removeSelected()"
              pTooltip="Delete the page's content (it isn't on the website)"></button>
    </div>
    <div class="meta">Publishing ships just this suburb to the website preview; production follows from the Website page.</div>
  </ng-container>
  <ng-template #needsRegion><div class="text-600 text-sm">Put the suburb in a region first: its page lives under the region's address.</div></ng-template>
</section>

<section *ngIf="gate as gate">
  <div class="lbl">Search gate <span class="meta-inline">report only</span></div>
  <ng-container *ngIf="gate.main as m">
    <div>
      <strong [class.ok]="m.pass" [class.warn]="!m.pass">{{ m.pass ? 'Passes' : 'Doesn\'t pass' }}</strong>
      <span class="text-600"> · indexed today: {{ m.indexableNow ? 'yes' : 'no' }}</span>
    </div>
    <ul class="gates">
      <li [class.ok]="m.gates?.g1?.pass"><i class="pi" [ngClass]="m.gates?.g1?.pass ? 'pi-check' : 'pi-times'"></i>
        Places nearby: {{ m.gates?.g1?.within ?? 0 }} within {{ m.gates?.g1?.radiusKm }} km (3 needed){{ nearbyNote(m.gates?.g1) }}</li>
      <li [class.ok]="m.gates?.g2?.pass"><i class="pi" [ngClass]="m.gates?.g2?.pass ? 'pi-check' : 'pi-times'"></i>
        Lead ({{ leadSource(m.gates?.g2) }}): {{ m.gates?.g2?.reason }}</li>
      <li [class.ok]="m.gates?.g3?.pass"><i class="pi" [ngClass]="m.gates?.g3?.pass ? 'pi-check' : 'pi-times'"></i>
        Own words: {{ pct(m.gates?.g3?.shared) }} of the page is shared with other suburbs in the region (60% at most)</li>
      <li [class.ok]="m.gates?.g4?.pass"><i class="pi" [ngClass]="m.gates?.g4?.pass ? 'pi-check' : 'pi-times'"></i>
        Places listed: {{ m.gates?.g4?.places ?? 0 }}</li>
    </ul>
  </ng-container>
  <div *ngIf="!gate.main" class="text-600 text-sm">No funeral-services page in the last build.</div>
  <div class="meta">Other service pages: {{ gate.others.pass }} of {{ gate.others.total }} pass. From the website build of {{ gate.reportedAt | date: 'd MMM y, h:mm a' }}. Indexing doesn't follow this yet.</div>
</section>

<section>
  <div class="lbl">What the crawl found</div>
  <div *ngIf="detail.detail.crawl; else noCrawlShort"><span class="bucket" [class]="'b-' + detail.detail.crawl.bucket">{{ detail.detail.crawl.bucket }}</span> score {{ detail.detail.crawl.score }} · {{ detail.detail.crawl.venueCount | number }} venues · {{ detail.detail.crawl.landmarkCount }} landmarks</div>
  <ng-template #noCrawlShort><div class="text-600 text-sm">Nothing.</div></ng-template>
  <button pButton type="button" class="p-button-text p-button-sm px-0" label="See the data" (click)="nav.setTab('data')"></button>
</section>

<section *ngIf="state.view === 'list'">
  <button pButton type="button" class="p-button-sm p-button-outlined" icon="pi pi-map" label="Show on the map" (click)="nav.flyTo(code)"></button>
</section>
